import { accessibility } from './modules/accessibility'
import { arrangements } from './modules/arrangements'
import { bannerForms } from './modules/bannerForms'
import { counter } from './modules/counter'
import { devicecheck } from './modules/devicecheck'
import { dialog } from './modules/dialog'
import { facts } from './modules/facts'
import { iframeHeightCalc } from './modules/iframeHeightCalc'
import { lightbox } from './modules/lightbox'
import { nav } from './modules/nav'
import { onScroll } from './modules/onScroll'
import { openFilter } from './modules/openFilter'
import { popups } from './modules/popups'
import { preload } from './modules/preload'
import { rooms } from './modules/rooms'
import { slider } from './modules/slider'
import { toggleItem } from './modules/toggleItem'

window.onload = function () {
	slider()
	onScroll()
	preload()
	nav()
	openFilter()
	lightbox()
	counter()
	dialog()
	toggleItem()
	facts()
	bannerForms()
	accessibility()
	iframeHeightCalc()
	devicecheck()
	popups()
	rooms()
	arrangements()
}
